import React from 'react';

import PropTypes from 'prop-types';

const Filter = ({ filterString, setFilterString }) => {
  return (
    <>
      <input
        type="text"
        style={{ width: '30%', border: '1px solid #4b286d' }}
        placeholder="Search by channel..."
        value={filterString}
        onChange={({ target: { value } }) => {
          setFilterString(value);
        }}
      />
    </>
  );
};
Filter.propTypes = {
  filterString: PropTypes.string.isRequired,
  setFilterString: PropTypes.func.isRequired
};
export default Filter;
